import { Injectable } from '@angular/core';
import { GmsapidataService } from 'src/app/core/services/gmsapidata.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { JsonValidatorComponent } from '../../json-validator/json-validator.component';
@Injectable()
export class FeatureOperationsService {
  uploadedFilesList: [];
  whackabingoAssets: [];
  featureAssets: any = {};
  constructor(private gmsApiService: GmsapidataService, private validatorComponent: JsonValidatorComponent) { }

  /* Returning Observable in subscription. */

  /* public getDataSub(reqObj, operation, featureName): Observable<any> {
    let msg = "";
    return this.gmsApiService.featureConfigCall(reqObj).pipe(map(response => {
      if (response) {
        msg = (operation == 'create') ? "Created" : "Updated";
        return msg;
      }
    }));
  } */

  /* Returning the callback function. */
  /* Using this method to get the list of all feature names to display in the dropdown. */
  getFeatureTypes(callBack) {
    this.gmsApiService.getFeatureTypeCall().pipe(take(1)).subscribe((response: any) => {
      if (response) callBack(response);
    });
  }

  /* Using this method to get the list of features for the specific feature. */

  getFeaturesList(reqObj, callBack) {
    this.gmsApiService.getFeatureListCall(reqObj).pipe(take(1)).subscribe((response: any) => {
      if (response) callBack(response);
    });
  }

  /* Using this method for the feature operations like create/edit/clone. */

  featureOperation(reqObj, callBack) {
    this.gmsApiService.featureConfigCall(reqObj).pipe(take(1)).subscribe((response: any) => {
      if (response) callBack(response);
    });
  }

  featureClone(reqObj, callBack) {
    this.gmsApiService.featureCloneCall(reqObj).pipe(take(1)).subscribe((response: any) => {
      if (response) callBack(response);
    });
  }

  setFeatureAssets(assets) {
    this.whackabingoAssets = assets;
    if (this.whackabingoAssets != undefined) {
      this.getFeatureAssets();
    }
  }

  getFeatureAssets(): Observable<any> {
    let data = this.whackabingoAssets != undefined ? this.whackabingoAssets : [];
    return of(data);
  }
  uploadMediaImageFile(fileData, key, inputData, callBack) {
    let data = [];
    this.uploadedFilesList = inputData.uploadedFilesList;
    //let updatedData: any;
    let uploadFile = fileData.target.files[0];
    let sndFileSize = ((uploadFile.size) / 300) / 300;
    let fileExtension = '.' + uploadFile.name.split('.')[1];
    let filenamePrefix = uploadFile.name.split('.')[0];
    let hasWhiteSpaceRegEx = new RegExp('\\s+');
    if (this.validatorComponent.validateStrWithRegExp(hasWhiteSpaceRegEx, filenamePrefix) == true) {
      return "error";
    } else {
      var imgdata: any;
      const fReader = new FileReader();
      let img;
      fReader.onload = (e) => {
        img = e.target.result;
        imgdata = {
          'image_path': inputData.featureSetVal.name + '_' + key + fileExtension,
          'name': "scratch_card_media_img",
          'image_data': img,
          "index": key
        };
        imgdata.image_path = imgdata.image_path.replace(/ /g, "-");
        imgdata.image_data = imgdata.image_data.replace("data:image/png;base64", "b@imgpb@");
        data = this.removeDuplicates(data, key, imgdata, fileExtension);
        this.uploadedFilesList = this.removeDuplicates(this.uploadedFilesList, key, imgdata, fileExtension);
        this.uploadFileSet(data, inputData, key, (response) => {
          let updatedData = response;
          Object.assign(updatedData, { "uploadedFilesList": this.uploadedFilesList });
          console.log("api-res---->", updatedData)
          //return updatedData;
          //console.log("apppppp---->",response);
          callBack(updatedData);
        });
      };
      fReader.readAsDataURL(uploadFile);
    }
  }
  removeDuplicates(list, id, data, extension) {
    let datalist = list;
    datalist.forEach((element, index) => {
      if (element.index == id) {
        datalist.splice(index, 1);
      }
    });
    datalist.push(data);
    return datalist;
  }
  uploadFileSet(data, inputData, i, callBack) {
    //console.log(this.uploadedFilesList.length)
    this.gmsApiService.multimediaUpload(data).pipe(take(1)).subscribe((response: any) => {
      if (response) {
        let extension = '.' + response[0]['path'].split('.')[1];
        let path = response[0]['path'] + '?' + this.getRandomNumber();
        if (!isNaN(i)) {
          inputData.symbols[i]['image'] = path; //response[0]['path']; // this.data[0].image_data;
        } else if (extension == '.png') {
          let field = i + '_img';
          inputData.featureSetVal[field] = path;
        } else if (extension == '.mp3') {
          let field = 'audio_' + i;
          inputData.featureSetVal[field] = path;
        }
        // let fullpath = response[0]['full_path'];
        // let idx = this.filesListToBeDeleted.indexOf(fullpath);
        // if (idx > -1) {
        //   this.filesListToBeDeleted[idx] = fullpath;
        // } else {
        //   this.filesListToBeDeleted.push(fullpath);
        // }
        data = [];
        callBack(inputData);
        //return inputData;
      }
    });
    //this.hasError = false;
  }
  getRandomNumber() {
    return new Date().getTime();
  }

  uploadAssets(request, callBack) {
    this.gmsApiService.multimediaUpload(request).pipe(take(1)).subscribe((response: any) => {
      if (response) callBack(response);
    });
  }

  extrnlOrChatFeatureConfig(reqObj, callBack) {
    this.gmsApiService.manageGameFeature(reqObj).pipe(take(1)).subscribe((response: any) => {
      if (response) callBack(response);
    });
  }

  setFeatureAssetData(assets) {
    this.featureAssets = assets;
  }

  getFeatureAssetData() {
    return JSON.parse(JSON.stringify(this.featureAssets));
  }

  isDuplicateFeatureName(featureName, callBack) {
    let payload = { "feature_name": featureName };
    this.gmsApiService.validateFeatureName(payload).subscribe(response => {
      callBack(response ?? false);
    });
  }

  isTournamentFeature(featureName): boolean {
    return featureName?.toLowerCase()?.startsWith("tournament_");
  }
}
